import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { ADDRESS_PROOF_OPTIONS } from "../../../config/constant";
import UploadInput from "../../../components/UploadInput";
import { removeBlobImages } from "../../../utilis/common-funtions";
import UploadPopupTwoImages from "../../../shared-components/upload-popup/UploadPopupTwoImages";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import SelectInput from "../../../components/SelectInput";

const NoDigilockerAccountFields = ({ formik, applicantNo }) => {
  const { isLoading, applicantData } = useSelector(
    (state) => state?.newBookingForm
  );
  const { t } = useTranslation();
  const [showUpload, setShowUpload] = useState({
    panImage: false,
    aadharImage: false,
    addressProof: false,
    passportImage: false,
    ociCardImage: false,
  });

  const applicantKey = `applicant${applicantNo}`;
  const personalDetails = applicantData?.[applicantKey]?.personalDetails;
  const hasAadhaarName = Boolean(personalDetails?.isAadhaarVerified);
  const hasPanName = Boolean(personalDetails?.isPanVerified);
  const showPanUpload =
    personalDetails && !hasPanName ? true : !personalDetails ? true : false;
  const showAaddharUpload =
    personalDetails && !hasAadhaarName ? true : !personalDetails ? true : false;

  const toggleUpload = (key) => {
    removeBlobImages();
    setShowUpload((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleImageValue = (keyName, imgName) => {
    removeBlobImages();
    formik.setFieldValue(keyName, imgName);
  };

  const handleUpdateImageData = (fieldName, imageData) => {
    formik.setFieldValue(fieldName, imageData);
  };

  const handlePhysicalImage = (fieldName, value) => {
    formik.setFieldValue(fieldName,value)
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {showAaddharUpload && (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          className="widthFullUploadInput"
        >
          <UploadInput
            field={{
              name: "aadhaarImage",
              label: t(
                "authorizedSignatoryDetails.fields.aadhaarImage.upload.placeholder"
              ),
              required:
                formik.values?.residentStatus !==
                t("residentStatusOptions.PIO_OCI"),
              readonly: false,
              placeholder: t(
                "authorizedSignatoryDetails.fields.aadhaarImage.upload.placeholder"
              ),
              placeholderUpload: t("commonPlaceholders.uploaded"),
              handleOnClick: () => toggleUpload("aadharImage"),
            }}
            formik={formik}
            disabled={formik.values.isAadhaarSkipped}
          />
          {!(
            formik.values?.residentStatus === t("residentStatusOptions.PIO_OCI")
          ) && (
            <FormControlLabel
              control={
                <Checkbox
                  id="isAadhaarSkipped"
                  name="isAadhaarSkipped"
                  size="small"
                  color="primary"
                  checked={formik.values.isAadhaarSkipped}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    formik.setFieldValue("isAadhaarSkipped", checked);
                    if (checked) {
                      formik.setFieldValue("aadhaarImage", []);
                    } else {
                      formik.setFieldValue("passportHaveCurrentAddress", true);
                    }
                  }}
                  sx={{
                    "&.Mui-checked": {
                      color: "#1A407D",
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ fontSize: "14px", color: "#1C252E" }}>
                  {t("commonLabels.appliedforAadhaar")}
                </Typography>
              }
            />
          )}
        </Grid>
      )}
      {showPanUpload && (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          className="widthFullUploadInput"
        >
          <UploadInput
            field={{
              name: "panImage",
              label: t(
                "authorizedSignatoryDetails.fields.panNumberImage.upload.placeholder"
              ),
              required: true,
              readonly: false,
              placeholder: t(
                "authorizedSignatoryDetails.fields.panNumberImage.upload.placeholder"
              ),
              placeholderUpload: t("commonPlaceholders.uploaded"),

              handleOnClick: () => toggleUpload("panImage"),
            }}
            formik={formik}
            disabled={formik.values.isPanSkipped}
          />
          <FormControlLabel
            control={
              <Checkbox
                id="isPanSkipped"
                name="isPanSkipped"
                size="small"
                color="primary"
                checked={formik.values.isPanSkipped}
                onChange={(e) => {
                  const checked = e.target.checked;
                  formik.setFieldValue("isPanSkipped", checked);
                  if (checked) {
                    formik.setFieldValue("panImage", []);
                  }
                }}
                sx={{
                  "&.Mui-checked": {
                    color: "#1A407D",
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: "14px", color: "#1C252E" }}>
                {t("commonLabels.appliedforPan")}
              </Typography>
            }
          />
        </Grid>
      )}
      {[
        t("residentStatusOptions.NRI"),
        t("residentStatusOptions.PIO_OCI"),
      ].includes(formik.values?.residentStatus) && (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          className="widthFullUploadInput"
        >
          <UploadInput
            field={{
              name: "passportImage",
              label: t("authorizedSignatoryDetails.fields.passportImage.label"),
              required: true,
              readonly: false,
              placeholder:  formik?.values?.isPhysicalPassport?t(
                "authorizedSignatoryDetails.fields.passportImage.upload.physicalCopy"
              ) : t(
                "authorizedSignatoryDetails.fields.passportImage.upload.placeholder"
              ),
              placeholderUpload: t("commonPlaceholders.uploaded"),
              handleOnClick: () => toggleUpload("passportImage"),
            }}
            formik={formik}
          />
          <FormControlLabel
            control={
              <Checkbox
                id="passportHaveCurrentAddress"
                name="passportHaveCurrentAddress"
                size="small"
                checked={formik.values.passportHaveCurrentAddress}
                onChange={(e) => {
                  const checked = e.target.checked;
                  formik.setFieldValue("passportHaveCurrentAddress", checked);
                  if (checked) {
                    formik.setFieldValue("addressProofType", null);
                    formik.setFieldValue("addressProofImage", []);
                  }
                }}
                sx={{
                  "&.Mui-checked": {
                    color: "#1A407D",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.26)",
                  },
                }}
                disabled={
                  !formik.values?.isAadhaarSkipped &&
                  formik.values?.residentStatus !==
                    t("residentStatusOptions.PIO_OCI")
                }
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#1C252E",
                  ".Mui-disabled &": {
                    color: "rgba(0, 0, 0, 0.26)",
                  },
                }}
              >
                {t(
                  "authorizedSignatoryDetails.fields.passportHaveCurrentAddress.label"
                )}
              </Typography>
            }
          />
        </Grid>
      )}
      {formik.values?.residentStatus === t("residentStatusOptions.PIO_OCI") && (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          className="widthFullUploadInput"
        >
          <UploadInput
            field={{
              name: "ociCardImage",
              label: t("authorizedSignatoryDetails.fields.ociCardImage.label"),
              required: true,
              readonly: false,
              placeholder: formik?.values?.isPhysicalOCI ? t(
                "authorizedSignatoryDetails.fields.ociCardImage.upload.physicalCopy"
              ):t(
                "authorizedSignatoryDetails.fields.ociCardImage.upload.placeholder"
              ),
              placeholderUpload: t("commonPlaceholders.uploaded"),
              handleOnClick: () => toggleUpload("ociCardImage"),
            }}
            formik={formik}
          />
        </Grid>
      )}
      {([
        t("residentStatusOptions.NRI"),
        t("residentStatusOptions.PIO_OCI"),
      ].includes(formik.values?.residentStatus)
        ? !formik.values.passportHaveCurrentAddress
        : formik.values.isAadhaarSkipped) && (
        <>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={6}
            className="widthFullUploadInput"
          >
            <Typography
              sx={{
                marginBottom: "6px",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              {t(
                "authorizedSignatoryDetails.fields.addressProofImage.imageLabel"
              )}{" "}
              <span className="asteriskColor"> *</span>
            </Typography>
            <SelectInput
              field={{
                name: "addressProofType",
                readonly: false,
                options: ADDRESS_PROOF_OPTIONS,
                placeholder: t(
                  "authorizedSignatoryDetails.fields.addressProofImage.placeholder"
                ),
              }}
              formik={formik}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={6}
            className="widthFullUploadInput"
          >
            <UploadInput
              field={{
                name: "addressProofImage",
                label: t(
                  "authorizedSignatoryDetails.fields.addressProofImage.upload.placeholder"
                ),
                required: true,
                readonly: false,
                placeholder: formik?.values?.isPhysicalAddressProof ? t(
                  "authorizedSignatoryDetails.fields.addressProofImage.upload.physicalCopy"
                ): t(
                  "authorizedSignatoryDetails.fields.addressProofImage.upload.placeholder"
                ),
                placeholderUpload: t("commonPlaceholders.uploaded"),

                handleOnClick: () => toggleUpload("addressProof"),
              }}
              formik={formik}
            />
          </Grid>
        </>
      )}
      {showUpload?.aadharImage && (
        <UploadPopupTwoImages
          heading={t(
            "authorizedSignatoryDetails.fields.aadhaarImage.popup.heading"
          )}
          totalImages={2}
          closePopup={() => toggleUpload("aadharImage")}
          handleImageValue={handleImageValue}
          uploadedImageFront={formik?.values?.aadhaarImage?.[0] || []}
          uploadedImageBack={formik?.values?.aadhaarImage?.[1] || []}
          fieldName={"aadhaarImage"}
          handleUpdateImageData={handleUpdateImageData}
          hidePhysicalCopyOption={true}
        />
      )}
      {showUpload?.panImage && (
        <UploadPopup
          heading={t(
            "authorizedSignatoryDetails.fields.panNumberImage.popup.heading"
          )}
          totalImages={1}
          closePopup={() => toggleUpload("panImage")}
          handleImageValue={handleImageValue}
          uploadedImage={formik?.values?.panImage}
          fieldName={"panImage"}
          handleUpdateImageData={handleUpdateImageData}
          hidePhysicalCopyOption
        />
      )}
      {showUpload?.addressProof && (
        <UploadPopup
          heading={t(
            "authorizedSignatoryDetails.fields.addressProofImage.popup.heading"
          )}
          totalImages={1}
          closePopup={() => toggleUpload("addressProof")}
          handleImageValue={handleImageValue}
          uploadedImage={formik?.values?.addressProofImage}
          fieldName={"addressProofImage"}
          handleUpdateImageData={handleUpdateImageData}
          handlePhysicalImage={(field,val)=>{handlePhysicalImage('isPhysicalAddressProof',val)}}
          selectedOptionValue={formik?.values?.isPhysicalAddressProof}
        />
      )}
      {showUpload?.passportImage && (
        <UploadPopup
          heading={t(
            "authorizedSignatoryDetails.fields.passportImage.popup.heading"
          )}
          totalImages={1}
          closePopup={() => toggleUpload("passportImage")}
          handleImageValue={handleImageValue}
          uploadedImage={formik?.values?.passportImage}
          fieldName="passportImage"
          handleUpdateImageData={handleUpdateImageData}
          handlePhysicalImage={(field,val)=>{handlePhysicalImage('isPhysicalPassport',val)}}
          selectedOptionValue={formik?.values?.isPhysicalPassport}
        />
      )}
      {showUpload?.ociCardImage && (
        <UploadPopup
          heading={t(
            "authorizedSignatoryDetails.fields.ociCardImage.popup.heading"
          )}
          totalImages={1}
          closePopup={() => toggleUpload("ociCardImage")}
          handleImageValue={handleImageValue}
          uploadedImage={formik?.values?.ociCardImage}
          fieldName="ociCardImage"
          handleUpdateImageData={handleUpdateImageData}
          handlePhysicalImage={(field,val)=>{handlePhysicalImage('isPhysicalOCI',val)}}
          selectedOptionValue={formik?.values?.isPhysicalOCI}

        />
      )}
    </>
  );
};

export default NoDigilockerAccountFields;
